import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './SuccessMessage.styles';

export interface SuccessMessageProps {
  onClick?: () => void;
}

export function SuccessMessage({ onClick }: SuccessMessageProps) {
  const slots = styles();
  const t = useTranslations('review.form.success');

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('title')}</h2>
      <p className={slots.description()}>{t('description')}</p>
      <UiKitButtonBase
        color="secondary"
        className={slots.button()}
        onClick={onClick}
      >
        {t('button')}
      </UiKitButtonBase>
    </div>
  );
}
